/* LOSMIOS product — variants, AJAX cart (Dawn drawer/notification + fallback),
   qty, low-stock, save%, sku, variant->image, lightbox, share, sticky. No deps. */
(function () {
  function money(format, cents) {
    return (format || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2));
  }

  function init(root) {
    if (!root || root.dataset.lmInit) return;
    root.dataset.lmInit = '1';

    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-lm-variants]').textContent); } catch (e) { return; }
    var EN = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;

    var moneyFormat = root.dataset.moneyFormat || '${{amount}}';
    var lowThreshold = parseInt(root.dataset.low, 10) || 0;
    var form = root.querySelector('[data-lm-form]');
    var idInput = root.querySelector('[data-lm-variant-id]');
    var priceEl = root.querySelector('[data-lm-price]');
    var saveEl = root.querySelector('[data-lm-save]');
    var skuWrap = root.querySelector('[data-lm-sku]');
    var skuVal = root.querySelector('[data-lm-sku-val]');
    var stockEl = root.querySelector('[data-lm-stock]');
    var stockText = root.querySelector('[data-lm-stock-text]');
    var atc = root.querySelector('[data-lm-atc]');
    var atcLabel = root.querySelector('[data-lm-atc-label]');
    var atcOriginal = atcLabel ? atcLabel.textContent : '';
    var stickyPrice = root.querySelector('[data-lm-sticky-price]');
    var strings = window.variantStrings || {};

    function selectedOptions() {
      var opts = [];
      root.querySelectorAll('[data-lm-option]').forEach(function (g) {
        var checked = g.querySelector('input:checked');
        opts[parseInt(g.dataset.lmOption, 10)] = checked ? checked.value : null;
        var lbl = g.querySelector('[data-lm-opt-current]');
        if (lbl && checked) lbl.textContent = checked.value;
      });
      return opts;
    }
    function findVariant(opts) {
      return variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
    }
    function markAvailability(opts) {
      root.querySelectorAll('[data-lm-option]').forEach(function (g) {
        var idx = parseInt(g.dataset.lmOption, 10);
        g.querySelectorAll('.lm-chip').forEach(function (chip) {
          var input = chip.querySelector('input');
          var match = variants.find(function (v) {
            return v.options.every(function (o, i) { return i === idx ? o === input.value : (opts[i] == null || o === opts[i]); });
          });
          chip.classList.toggle('is-unavailable', !!match && !match.available);
        });
      });
    }
    function switchImage(mediaId) {
      if (mediaId == null) return;
      var thumb = root.querySelector('[data-lm-thumb][data-media-id="' + mediaId + '"]');
      if (thumb) activateThumb(thumb);
    }
    function update() {
      var opts = selectedOptions();
      markAvailability(opts);
      var v = findVariant(opts);
      if (!v && variants.length === 1) v = variants[0];
      if (!v) {
        if (atc) { atc.disabled = true; if (atcLabel) atcLabel.textContent = strings.unavailable || 'No disponible'; }
        return;
      }
      if (idInput) idInput.value = v.id;

      var nowStr = v.price_str != null ? v.price_str : money(moneyFormat, v.price);
      var wasStr = v.compare_str != null ? v.compare_str : money(moneyFormat, v.compare_at_price);
      var html;
      if (v.compare_at_price && v.compare_at_price > v.price) {
        html = '<span class="lm-price__was">' + wasStr + '</span><span class="lm-price__now--sale">' + nowStr + '</span>';
        if (saveEl) { saveEl.hidden = false; saveEl.textContent = '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'; }
      } else {
        html = nowStr;
        if (saveEl) saveEl.hidden = true;
      }
      if (priceEl) priceEl.innerHTML = html;
      if (stickyPrice) stickyPrice.textContent = nowStr;

      if (skuWrap) { if (v.sku) { skuWrap.hidden = false; if (skuVal) skuVal.textContent = v.sku; } else skuWrap.hidden = true; }

      if (stockEl) {
        var tracked = v.inventory_management === 'shopify' && v.inventory_policy === 'deny';
        if (v.available && tracked && v.inventory_quantity > 0 && v.inventory_quantity <= lowThreshold) {
          stockEl.hidden = false; stockEl.classList.add('lm-stock--low');
          stockText.textContent = EN ? ('Only ' + v.inventory_quantity + ' left!') : ('¡Solo quedan ' + v.inventory_quantity + '!');
        } else if (v.available) {
          stockEl.hidden = false; stockEl.classList.remove('lm-stock--low');
          stockText.textContent = EN ? 'In stock, ready to ship' : 'En stock, listo para enviar';
        } else { stockEl.hidden = true; }
      }

      if (atc) {
        atc.disabled = !v.available;
        if (atcLabel) atcLabel.textContent = v.available ? (atcOriginal || strings.addToCart || (EN ? 'Add to cart' : 'Agregar al carrito')) : (EN ? 'SOLD OUT' : 'AGOTADO');
      }
      switchImage(v.media_id);

      if (history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u.toString());
      }
    }

    root.querySelectorAll('[data-lm-option] input').forEach(function (i) { i.addEventListener('change', update); });

    // Quantity
    var qtyInput = root.querySelector('[data-lm-qty-input]');
    root.querySelectorAll('[data-lm-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = parseInt(qtyInput.value, 10) || 1;
        n += parseInt(b.dataset.lmQty, 10);
        qtyInput.value = Math.max(1, n);
      });
    });

    // Gallery thumbs
    var main = root.querySelector('[data-lm-main-img]');
    function activateThumb(t) {
      if (main) { main.src = t.dataset.full; main.srcset = ''; if (t.dataset.zoom) main.dataset.zoom = t.dataset.zoom; }
      root.querySelectorAll('[data-lm-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
    }
    root.querySelectorAll('[data-lm-thumb]').forEach(function (t) {
      t.addEventListener('click', function () { activateThumb(t); });
    });

    // Lightbox
    var lb = root.querySelector('[data-lm-lightbox]');
    var lbImg = root.querySelector('[data-lm-lightbox-img]');
    var zoomArea = root.querySelector('[data-lm-zoom]');
    function openLb() { if (!lb || !main) return; lbImg.src = main.dataset.zoom || main.src; lb.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function closeLb() { if (!lb) return; lb.classList.remove('is-open'); document.body.style.overflow = ''; }
    if (zoomArea) zoomArea.addEventListener('click', openLb);
    if (lb) { lb.addEventListener('click', function (e) { if (e.target === lb || e.target.hasAttribute('data-lm-lightbox-close')) closeLb(); }); }
    document.addEventListener('keyup', function (e) { if (e.key === 'Escape') closeLb(); });

    // Share
    var shareBtn = root.querySelector('[data-lm-share]');
    if (shareBtn) {
      shareBtn.addEventListener('click', function () {
        var data = { title: shareBtn.dataset.title, url: shareBtn.dataset.url };
        if (navigator.share) navigator.share(data).catch(function () {});
        else { navigator.clipboard && navigator.clipboard.writeText(shareBtn.dataset.url); var t = shareBtn.textContent; shareBtn.textContent = '✓ Enlace copiado'; setTimeout(function () { shareBtn.textContent = t; }, 1800); }
      });
    }

    // AJAX add to cart
    function cartElement() { return document.querySelector('cart-drawer') || document.querySelector('cart-notification'); }
    function updateBubble() {
      fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js')
        .then(function (r) { return r.json(); })
        .then(function (c) { document.querySelectorAll('.cart-count-bubble span[aria-hidden], [data-cart-count]').forEach(function (el) { el.textContent = c.item_count; }); })
        .catch(function () {});
    }
    function burst() {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var colors = ['#00FF87', '#FFD24A', '#F4F7F2', '#FF3B5C'];
      var r = atc ? atc.getBoundingClientRect() : { left: window.innerWidth / 2, top: window.innerHeight * 0.6, width: 0, height: 0 };
      var ox = r.left + r.width / 2, oy = r.top + r.height / 2;
      for (var i = 0; i < 42; i++) {
        var c = document.createElement('div');
        c.style.cssText = 'position:fixed;z-index:9998;width:9px;height:9px;border-radius:1px;pointer-events:none;left:' + ox + 'px;top:' + oy + 'px;background:' + colors[i % 4];
        document.body.appendChild(c);
        var dx = (Math.random() - 0.5) * 460, dy = -(140 + Math.random() * 420);
        c.animate([{ transform: 'translate(-50%,-50%) rotate(0)', opacity: 1 }, { transform: 'translate(' + dx + 'px,' + dy + 'px) rotate(' + (Math.random() * 720) + 'deg)', opacity: 0 }], { duration: 950 + Math.random() * 650, easing: 'cubic-bezier(.2,.8,.3,1)' }).onfinish = function () { this.effect.target.remove(); };
      }
    }
    function toast(title) {
      var existing = document.querySelector('.lm-toast'); if (existing) existing.remove();
      var el = document.createElement('div');
      el.className = 'lm-toast';
      el.innerHTML = '<p class="lm-toast__title">' + (EN ? 'Added to cart ✓' : 'Agregado al carrito ✓') + '</p><p class="lm-toast__text">' + title + '</p><div class="lm-toast__actions"><a class="lm-toast__cart" href="/cart">' + (EN ? 'View cart' : 'Ver carrito') + '</a><a class="lm-toast__checkout" href="/checkout">Checkout</a></div>';
      document.body.appendChild(el);
      requestAnimationFrame(function () { el.classList.add('is-open'); });
      setTimeout(function () { el.classList.remove('is-open'); setTimeout(function () { el.remove(); }, 400); }, 5000);
    }
    function addToCart() {
      if (!form || atc.disabled) return;
      var fd = new FormData(form);
      var cart = cartElement();
      var headers = { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        try {
          var ids = cart.getSectionsToRender().map(function (s) { return s.id; });
          fd.append('sections', ids.join(','));
          fd.append('sections_url', window.location.pathname);
        } catch (e) {}
      }
      atc.classList.add('is-disabled');
      var prev = atcLabel ? atcLabel.textContent : '';
      if (atcLabel) atcLabel.textContent = (EN ? 'Adding…' : 'Agregando…');
      fetch('/cart/add.js', { method: 'POST', headers: headers, body: fd })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { if (atcLabel) atcLabel.textContent = res.description || 'Error'; return; }
          if (cart && typeof cart.renderContents === 'function') {
            cart.renderContents(res);
            if (cart.tagName === 'CART-DRAWER' && typeof cart.open === 'function') cart.open();
          } else {
            toast(res.product_title || document.querySelector('.lm-pdp__title').textContent);
          }
          updateBubble();
          var lmQty = parseInt(fd.get('quantity'), 10) || 1;
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { source: 'lm-product', data: { source: 'product-form-component', itemCount: lmQty, variantId: idInput && idInput.value, resource: res } } }));
          document.dispatchEvent(new CustomEvent('lm:cart:changed'));
          burst();
        })
        .catch(function () { toast(document.querySelector('.lm-pdp__title').textContent); })
        .finally(function () { atc.classList.remove('is-disabled'); if (atcLabel) atcLabel.textContent = prev; });
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(); });
    if (atc) atc.addEventListener('click', function (e) { e.preventDefault(); addToCart(); });
    var buynow = root.querySelector('[data-lm-buynow]');
    if (buynow) buynow.addEventListener('click', function (e) {
      e.preventDefault();
      if (buynow.disabled || !idInput || !idInput.value) return;
      buynow.classList.add('is-disabled');
      var qInput = root.querySelector('[data-lm-qty-input]');
      var q = qInput ? (parseInt(qInput.value, 10) || 1) : 1;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' }, body: JSON.stringify({ items: [{ id: parseInt(idInput.value, 10), quantity: q }] }) })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function () { buynow.classList.remove('is-disabled'); window.location.href = '/cart'; });
    });

    // Sticky ATC
    var sticky = root.querySelector('[data-lm-sticky]');
    if (sticky && atc) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { sticky.classList.toggle('is-visible', !e.isIntersecting); });
      }, { threshold: 0 });
      obs.observe(atc);
      var sbtn = sticky.querySelector('[data-lm-sticky-btn]');
      if (sbtn) sbtn.addEventListener('click', addToCart);
    }

    // Bundle: agregar kit completo (main + items del kit en 1 click)
    var kitBtn = root.querySelector('[data-lm-add-kit]');
    if (kitBtn) {
      kitBtn.addEventListener('click', function () {
        var ids = [];
        if (idInput && idInput.value) ids.push(idInput.value);
        root.querySelectorAll('[data-lm-kit-variant]').forEach(function (el) { if (el.dataset.lmKitVariant) ids.push(el.dataset.lmKitVariant); });
        if (!ids.length) return;
        var items = ids.map(function (id) { return { id: id, quantity: 1 }; });
        var cart = cartElement();
        var body = { items: items };
        if (cart && typeof cart.getSectionsToRender === 'function') {
          try { body.sections = cart.getSectionsToRender().map(function (sr) { return sr.id; }).join(','); body.sections_url = window.location.pathname; } catch (e) {}
        }
        var prev = kitBtn.textContent; kitBtn.classList.add('is-disabled'); kitBtn.textContent = (EN ? 'Adding…' : 'Agregando…');
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' }, body: JSON.stringify(body) })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) { kitBtn.textContent = res.description || 'Error'; return; }
            if (cart && typeof cart.renderContents === 'function') { cart.renderContents(res); if (cart.tagName === 'CART-DRAWER' && typeof cart.open === 'function') cart.open(); }
            else { toast(EN ? 'Kit added ✓' : 'Kit agregado ✓'); }
            updateBubble();
            document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { source: 'lm-product', data: { source: 'product-form-component', itemCount: items.length, resource: res } } }));
            document.dispatchEvent(new CustomEvent('lm:cart:changed'));
            burst();
          })
          .catch(function () { toast(EN ? 'Kit added ✓' : 'Kit agregado ✓'); })
          .finally(function () { kitBtn.classList.remove('is-disabled'); kitBtn.textContent = prev; });
      });
    }

    update();
  }

  function boot() { document.querySelectorAll('[data-lm-product]').forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('[data-lm-product]').forEach(init); });
})();
